import HomeView from "./security/components/home-view";
import AccessDeniedView from "./security/components/access-denied";
import PrivacyPolicyView from "./admin/components/privacy-policy/privacy-policy-view";
import AdminReportsView from "./admin/components/admin-reports-parent";
import AdminReportsViewFrame from "./admin/components/admin-reports-parent-frame";

export interface RouteConfigProps {
  path: string;
  protectedPageName?: string;
  component: any;
}

const RouteConfiguration: Array<RouteConfigProps> = [
  { path: "/", component: HomeView },

  {
    path: "/operations/reports",
    protectedPageName: "Reports",
    component: AdminReportsView,
  },
  {
    path: "/operations/reports/:reportId",
    protectedPageName: "Reports",
    component: AdminReportsView,
  },
  {
    path: "/operations/reports-iframe",
    protectedPageName: "Reports",
    component: AdminReportsViewFrame,
  },
  


  //access-denied
  { path: "/accessdenied", component: AccessDeniedView },

  // Misc
  { path: "/privacypolicy", component: PrivacyPolicyView },
  
];

export default RouteConfiguration;
